import React, { useEffect, useState } from "react";
import { Grid, Typography, Paper, Box } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CommonButton from "../../Components/InputComponents/CommonButton";
import { decryptId } from "../../Components/CryptoComponent";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";

const ClientDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // this is the encrypted id
  const decryptedId = decryptId(decodeURIComponent(id));

  const location = useLocation();

  const paginationState = location?.state?.pagination || {
    page: 0,
    rowsPerPage: 25,
  };

  const filterData = location?.state?.filterData || {
    name: "",
    phone: "",
    email: "",
    country: "",
    companyType: "",
    contactName: "",
    contactEmail: "",
    contactPhone: "",
    status: "",
  };
  const open = location?.state?.open || "";

  const [clientData, setClientData] = useState({});

  const getData = () => {
    axiosAPI
      ?.get(`/Client/listbyId/${decryptedId}`)
      .then((res) => {
        setClientData(res?.data?.data);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getData();
  }, []);

  return (
    <Paper sx={{ p: { xs: 2, sm: 3, md: 5 }, m: "auto", minHeight: "100%" }}>
      <Grid container justifyContent="flex-start" sx={{ mb: 3 }}>
        <Grid item>
          <CommonButton
            variant="contained"
            customColor="#B0BEC5"
            onClick={() =>
              navigate("/Clients", {
                state: {
                  pagination: paginationState,
                  filterData: filterData,
                  open: open,
                },
              })
            }
          >
            Back
          </CommonButton>
        </Grid>
      </Grid>
      <Typography
        variant="h5"
        sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
        mb={2}
      >
        Client Details
      </Typography>

      {/* Basic Information Section */}
      <Box
        sx={{
          mb: 4,
          border: "1px solid lightgrey",
          p: 3,
          borderRadius: "20px",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#f5f5f5",
            borderRadius: 2,
            px: 2,
            py: 1,
            mb: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
          >
            Basic Information
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {[
            { label: "Name", value: clientData?.CD_Name },
            { label: "Email", value: clientData?.CD_Email },
            { label: "Contact Number", value: clientData?.CD_Phone },
            { label: "Address", value: clientData?.CD_Address },
            { label: "Country", value: clientData?.CD_CountryName },
            { label: "Company Type", value: clientData?.CD_CompanyTypeName },
          ].map((item, index) => (
            <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
              <Box>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontFamily: "Geist, sans-serif",
                    fontSize: "18px",
                    mb: 0.5,
                  }}
                >
                  {item.label}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontFamily: "Geist, sans-serif",
                    fontSize: "16px",
                  }}
                >
                  {item.value || "—"}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Contact Person Details Section */}
      <Box
        sx={{
          mb: 4,
          border: "1px solid lightgrey",
          p: 3,
          borderRadius: "20px",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#f5f5f5",
            borderRadius: 2,
            px: 2,
            py: 1,
            mb: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
          >
            Contact Person Details
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {[
            { label: "Name", value: clientData?.CD_ContactPerson },
            { label: "Email", value: clientData?.CD_ContactPerson_Email },
            {
              label: "Phone Number",
              value: clientData?.CD_ContactPerson_Phone,
            },
          ].map((item, index) => (
            <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
              <Box>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontFamily: "Geist, sans-serif",
                    fontSize: "18px",
                    mb: 0.5,
                  }}
                >
                  {item.label}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontFamily: "Geist, sans-serif",
                    fontSize: "16px",
                  }}
                >
                  {item.value || "—"}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Additional Information Section */}
      <Box
        sx={{
          mb: 4,
          border: "1px solid lightgrey",
          p: 3,
          borderRadius: "20px",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#f5f5f5",
            borderRadius: 2,
            px: 2,
            py: 1,
            mb: 2,
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
          >
            Additional Information
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {[
            { label: "Branch", value: clientData?.CD_Branches },
            { label: "Status", value: clientData?.CD_StatusName },
          ].map((item, index) => (
            <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
              <Box>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontFamily: "Geist, sans-serif",
                    fontSize: "18px",
                    mb: 0.5,
                  }}
                >
                  {item.label}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontFamily: "Geist, sans-serif",
                    fontSize: "16px",
                  }}
                >
                  {item.value || "—"}
                </Typography>
              </Box>
            </Grid>
          ))}
          <Grid item xs={12} sm={6} md={4} lg={4}>
            <Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontFamily: "Geist, sans-serif",
                  fontSize: "18px",
                  mb: 0.5,
                }}
              >
                Notes
              </Typography>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontFamily: "Geist, sans-serif",
                  fontSize: "16px",
                }}
              >
                {clientData?.CD_Notes || "—"}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default ClientDetails;
